import React, { useEffect, useState } from "react";
import classes from "./Footer.module.css";
import SocialSection from "../SocialSection";
import { Link } from "react-router-dom";
import { MdPhoneInTalk, MdLocationPin } from "react-icons/md";
import { FaEnvelope, FaCalendarAlt } from "react-icons/fa";
import moment from "moment";
import API from "../../utils/api";

export default function Footer() {
  const currentYear = moment().format("YYYY");

  const [categories, setCategories] = useState([]);

  useEffect(() => {
    async function fetchCategories() {
      try {
        const res = await API.post("/categories.php", { action: "fetch" });
        const cats = Array.isArray(res.data) ? res.data : res.data?.data || [];
        // Only take first 6 categories
        setCategories(cats.slice(0, 6));
      } catch (err) {
        console.error("Failed to fetch categories:", err);
      }
    }
    fetchCategories();
  }, []);

  return (
    <div className="container-fluid p-0">
      <div className={classes.footerContainer}>
        <div className={classes.footerMainContent}>
          <div className={classes.footerTop}>
            <div className={classes.footerSection1}>
              <img
                src="/techmatter_uk_color_logo.png"
                alt="TechMatter"
                className={classes.footerLogo}
              />
              <p>
                TechMatter.co.uk helps you find hundreds of components and
                computer parts from top manufacturers, including Cisco, HP,
                Intel, Sony, and from top Data Media manufacturers to build,
                repair, or upgrade your computer systems.
              </p>
              <SocialSection />
            </div>

            <div className={classes.footerSection2}>
              <h4>Categories</h4>
              <ul>
                {categories.length > 0 ? (
                  categories.map((cat) => (
                    <li key={cat.id}>
                      <Link to={`/category/${cat.category_slug}`}>
                        {cat.categoryName}
                      </Link>
                    </li>
                  ))
                ) : (
                  <li>No categories found</li>
                )}
              </ul>
              <Link
                to="https://www.trustpilot.com/review/techmatter.co.uk"
                target="_blank"
              >
                <img
                  src="/trust-logo.svg"
                  alt="Trust Pilot Logo"
                  className={classes.trustLogo}
                  loading="lazy"
                />
              </Link>
            </div>

            <div className={classes.footerSection3}>
              <h4>Customer Services</h4>
              <ul>
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/terms-conditions">Terms & Conditions</Link>
                </li>
                <li>
                  <Link to="/shipping-policy">Shipping Policy</Link>
                </li>
                <li>
                  <Link to="/return-refund-policy">Return & Refund Policy</Link>
                </li>
                <li>
                  <Link to="/warranty-information">Warranty Information</Link>
                </li>{" "}
                <li>
                  <Link to="/billing-policy">Billing Policy</Link>
                </li>
                <li>
                  <Link to="/about">About</Link>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
              </ul>
            </div>

            <div className={classes.footerSection4}>
              <h4>Contact Information</h4>
              <ul>
                <li className={classes.contactList}>
                  <MdLocationPin />
                  <Link
                    to="https://maps.app.goo.gl/n7geUVWku7Qk1hMe9"
                    target="_blank"
                  >
                    F-10 Leaf house, Catherine Place, Harrow, HA1 2JW
                  </Link>
                </li>
                <li className={classes.contactList}>
                  <MdPhoneInTalk />
                  <Link to="tel:+442031293546">+44 20 3129 3546</Link>
                </li>
                <li className={classes.contactList}>
                  <FaEnvelope />
                  <Link to="mailto:sales@techmatter.co.uk">
                    sales@techmatter.co.uk
                  </Link>
                </li>
                <li className={classes.contactList}>
                  <FaCalendarAlt />
                  <p>Mon - Fri / 8:00AM - 5:00PM (GMT)</p>
                </li>
              </ul>
            </div>
          </div>

          <div className={classes.footerBottom}>
            <h4>
              © {currentYear}{" "}
              <Link to="https://techmatter.co.uk" className={classes.link}>
                TechMatter
              </Link>
              . All rights reserved.
            </h4>
            <img src="/payment-card.png" alt="TechMatter" />
          </div>
        </div>
      </div>
    </div>
  );
}
